export const sidebarContent = {
  scan: "Scan to access the Rayaldee Conference Resource Hub",
  footer:
    "<b>Abbreviations:</b> <b>25D</b>=25-hydroxyvitamin D; <b>BMI</b>=body mass index; <b>CKD</b>=chronic kidney disease; <b>CKD-MBD</b>=chronic kidney disease–mineral andbone disorder; <b>FGF23</b>=ﬁbroblast growth factor 23; <b>PTH</b>=parathyroid hormone; <b>SHPT</b>=secondary hyperparathyroidism.",
};
